import { emptyChecklist } from "../../data/test/empty";
import { newId } from "../id/id";
import { SerializedChecklistContents } from "../model/checklistSerialized";
import { defaultEditorOptions } from "../model/documentOptions";
import { ChecklistDocument } from "../model/editorState";

import { appStateFromSerialized } from "./convert";

export const newChecklistDocument = (
  contents: SerializedChecklistContents = emptyChecklist
): ChecklistDocument => {
  return {
    id: newId(),
    title: "",
    contents: appStateFromSerialized(contents),
    styles: {},
    layout: "twoColumn",
    options: defaultEditorOptions,
  };
};
